import { cn } from 'utils/cn';

interface Props {
	label: string;
	className?: string;
}

export function RotatedRibbon({ label, className }: Props) {
	return (
		<div class={cn('absolute z-10 -rotate-45 text-center', className)}>
			<div class="bg-red px-3 py-1 text-neutral-white w-32 uppercase text-sm font-bold leading-4">{label}</div>
		</div>
	);
}
